module.exports = __webpack_public_path__ + "img/style_3_7.2b2933b1.png";